module.exports = __webpack_public_path__ + "static/media/21ECLAC11.ecd5c5a7.jpg";